import { Component, OnInit } from '@angular/core'

@Component({
    templateUrl: './assignments-layout.component.html',
    styleUrl: './assignments-layout.component.scss',
})
export class AssignmentsLayoutComponent implements OnInit {
    ngOnInit(): void {}
}
